import * as THREE from 'three';

const FLOOR_COLOR = '#EFEFEF';
const TEXTURE_HEIGHT = 1024;
const TEXTURE_WIDTH = 16;

interface EditableGradientTexture {
  canvas: HTMLCanvasElement;
  texture: THREE.Texture;
}

export interface BackdropGradientTextures {
  bottom: EditableGradientTexture;
  top: EditableGradientTexture;
  wall: EditableGradientTexture;
}

export function createBackdropGradientTextures(
  hexColor: string,
): BackdropGradientTextures {
  const textures = {
    bottom: createEditableGradientTexture(),
    top: createEditableGradientTexture(),
    wall: createEditableGradientTexture(),
  };
  updateBackdropGradientTextures(textures, hexColor);
  return textures;
}

export function updateBackdropGradientTextures(
  textures: BackdropGradientTextures,
  hexColor: string,
) {
  drawGradient(textures.wall, [
    [0, hexColor],
    [0.42, hexColor],
    [0.7, FLOOR_COLOR],
    [1, FLOOR_COLOR],
  ]);
  drawGradient(textures.top, [[1, hexColor]]);
  drawGradient(textures.bottom, [[1, FLOOR_COLOR]]);
}

export function disposeBackdropGradientTextures(
  textures: BackdropGradientTextures,
) {
  textures.bottom.texture.dispose();
  textures.top.texture.dispose();
  textures.wall.texture.dispose();
}

function createEditableGradientTexture(): EditableGradientTexture {
  const canvas = document.createElement('canvas');
  canvas.width = TEXTURE_WIDTH;
  canvas.height = TEXTURE_HEIGHT;
  return {
    canvas,
    texture: new THREE.Texture(canvas),
  };
}

function drawGradient(
  { canvas, texture }: EditableGradientTexture,
  stops: ReadonlyArray<readonly [offset: number, color: string]>,
) {
  const context = canvas.getContext('2d');
  if (context) {
    const gradient = context.createLinearGradient(0, 0, 0, TEXTURE_HEIGHT);
    stops.forEach(([offset, color]) => gradient.addColorStop(offset, color));
    context.fillStyle = gradient;
    context.fillRect(0, 0, TEXTURE_WIDTH, TEXTURE_HEIGHT);
  }
  texture.needsUpdate = true;
}
